import axios from 'axios';
import { ApiUrlNuroSupportPage } from './constants';

const baseURL = ApiUrlNuroSupportPage.DOMAIN;

/**
 * NUROサポートページAPIを呼出す。
 * nuro-support-page-api
 */
const instance = axios.create({
  baseURL,
});

instance.interceptors.request.use((config) => {
  // サポートページ API は JSON 前提なので、呼び出し元ごとの差異をなくすためここで content-type を固定する。
  if (config.headers) {
    // eslint-disable-next-line no-param-reassign
    config.headers['content-type'] = 'application/json';
  } else {
    // eslint-disable-next-line no-param-reassign
    config.headers = { 'content-type': 'application/json' };
  }

  return config;
});

instance.interceptors.response.use(
  // 共通 instance 側では加工せず返し、画面ごとの分岐は hook 側に寄せる。
  (response) => response,
  (error) => {
    // エラーを握りつぶさず上位へ投げ、ログイン遷移や共通ダイアログ判断を呼び出し元で行う。
    throw error;
  }
);

export default instance;
